import { render } from "./footer.html?vue&type=template&id=41e7c7f3"
import script from "./footer.js?vue&type=script&lang=js"
export * from "./footer.js?vue&type=script&lang=js"

import "./footer.less?vue&type=style&index=0&lang=less"

import exportComponent from "/Users/vito.degioia/Documents/Projects/mb-fiori-2023/fiori-del-mulino/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__